import React, { useEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { connect, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import AddTier from "./components/AddTier"; // you’ll create similar to AddPlan
import { tierListingRequest, deleteTier } from "../tiers/redux/tierDispatcher"; 

function TiersListingTable({ tierListing }) {
  console.log("tier listing-----", tierListing?.tierDetail);
  const paginationModel = { page: 0, pageSize: 10 };

  const dispatch = useDispatch();
  const location = useLocation();

  const tiersListingHeading = [
    {
      field: "id",
      headerName: "NO",
      width: 40,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    {
      field: "name",
      headerName: "Tier Name",
      width: 250,
    },
    {
      field: "bump",
      headerName: "Monthly Bump",
      width: 150,
    },{
      field: "spotlight",
      headerName: "Monthly Spotlight",
      width: 150,
    },
    {
      field: "price",
      headerName: "Tier Monthly Price",
      width: 150,
    },

    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "4px",
              alignItems: "center",
              height: "100%",
            }}
          >
            <AddTier
              buttonLabel="Edit"
              editMode={true}
              tierData={params.row}
            />

            <button
              onClick={() => handleDelete(params.row)}
              style={{
                backgroundColor: "#F44336",
                color: "white",
                border: "none",
                cursor: "pointer",
                borderRadius: "4px",
                fontSize: "10px",
                width: "30%",
                height: "24px",
                padding: "2px 5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];

  const handleDelete = (row) => {
    console.log("Deleting Tier ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete tier "${row.name}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteTier(row.id));
      }
    });
  };

  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!fetchedRef.current) {
      fetchedRef.current = true;
    }
    dispatch(tierListingRequest());
  }, [dispatch, location.pathname]);

  return (
    <Paper sx={{ height: "95%", width: "100%" }}>
      <div style={{ padding: "10px", justifyItems: "end" }}>
        <AddTier buttonLabel={"Add Tier"} />
      </div>

      <DataGrid
        rows={tierListing.tierListing || []}
        columns={tiersListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
        rowHeight={80}
        loading={tierListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
      />
    </Paper>
  );
}

//Getting the state from the store
const mapStateToProps = (state) => {
  console.log("TIER:::::::::", state.tierReducer);
  return {
    tierListing: state.tierReducer,
  };
};

//passing the Tier Data in fetchTiers function
const mapDispatchToProps = (dispatch) => {
  return {
    tierListingRequest: () => dispatch({ type: "GET_TIER_REQUEST" }),
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(TiersListingTable);
